
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/csm-customer-service-management",
      function () {
        return require("private-next-pages/solutions/csm-customer-service-management/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/csm-customer-service-management"])
      });
    }
  